"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Instruction = _interopRequireDefault(require("./Instruction.js"));

var _GeometryType = _interopRequireDefault(require("../../geom/GeometryType.js"));

var _Relationship = _interopRequireDefault(require("../../extent/Relationship.js"));

var _VectorContext = _interopRequireDefault(require("../VectorContext.js"));

var _colorlike = require("../../colorlike.js");

var _extent = require("../../extent.js");

var _canvas = require("../canvas.js");

var _array = require("../../array.js");

var _inflate = require("../../geom/flat/inflate.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/render/canvas/Builder
 */


var CanvasBuilder =
/** @class */
function (_super) {
  __extends(CanvasBuilder, _super);
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */


  function CanvasBuilder(tolerance, maxExtent, resolution, pixelRatio) {
    var _this = _super.call(this) || this;
    /**
     * @protected
     * @type {number}
     */


    _this.tolerance = tolerance;
    /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */

    _this.maxExtent = maxExtent;
    /**
     * @protected
     * @type {number}
     */

    _this.pixelRatio = pixelRatio;
    /**
     * @protected
     * @type {number}
     */

    _this.maxLineWidth = 0;
    /**
     * @protected
     * @const
     * @type {number}
     */

    _this.resolution = resolution;
    /**
     * @private
     * @type {Array<*>}
     */

    _this.beginGeometryInstruction1_ = null;
    /**
     * @private
     * @type {Array<*>}
     */

    _this.beginGeometryInstruction2_ = null;
    /**
     * @private
     * @type {import("../../extent.js").Extent}
     */

    _this.bufferedMaxExtent_ = null;
    /**
     * @protected
     * @type {Array<*>}
     */

    _this.instructions = [];
    /**
     * @protected
     * @type {Array<number>}
     */

    _this.coordinates = [];
    /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */

    _this.tmpCoordinate_ = [];
    /**
     * @protected
     * @type {Array<*>}
     */

    _this.hitDetectionInstructions = [];
    /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */

    _this.state =
    /** @type {import("../canvas.js").FillStrokeState} */
    {};
    return _this;
  }
  /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */


  CanvasBuilder.prototype.applyPixelRatio = function (dashArray) {
    var pixelRatio = this.pixelRatio;
    return pixelRatio == 1 ? dashArray : dashArray.map(function (dash) {
      return dash * pixelRatio;
    });
  };
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */


  CanvasBuilder.prototype.appendFlatPointCoordinates = function (flatCoordinates, stride) {
    var extent = this.getBufferedMaxExtent();
    var tmpCoord = this.tmpCoordinate_;
    var coordinates = this.coordinates;
    var myEnd = coordinates.length;

    for (var i = 0, ii = flatCoordinates.length; i < ii; i += stride) {
      tmpCoord[0] = flatCoordinates[i];
      tmpCoord[1] = flatCoordinates[i + 1];

      if ((0, _extent.containsCoordinate)(extent, tmpCoord)) {
        coordinates[myEnd++] = tmpCoord[0];
        coordinates[myEnd++] = tmpCoord[1];
      }
    }

    return myEnd;
  };
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */


  CanvasBuilder.prototype.appendFlatLineCoordinates = function (flatCoordinates, offset, end, stride, closed, skipFirst) {
    var coordinates = this.coordinates;
    var myEnd = coordinates.length;
    var extent = this.getBufferedMaxExtent();

    if (skipFirst) {
      offset += stride;
    }

    var lastXCoord = flatCoordinates[offset];
    var lastYCoord = flatCoordinates[offset + 1];
    var nextCoord = this.tmpCoordinate_;
    var skipped = true;
    var i, lastRel, nextRel;

    for (i = offset + stride; i < end; i += stride) {
      nextCoord[0] = flatCoordinates[i];
      nextCoord[1] = flatCoordinates[i + 1];
      nextRel = (0, _extent.coordinateRelationship)(extent, nextCoord);

      if (nextRel !== lastRel) {
        if (skipped) {
          coordinates[myEnd++] = lastXCoord;
          coordinates[myEnd++] = lastYCoord;
          skipped = false;
        }

        coordinates[myEnd++] = nextCoord[0];
        coordinates[myEnd++] = nextCoord[1];
      } else if (nextRel === _Relationship["default"].INTERSECTING) {
        coordinates[myEnd++] = nextCoord[0];
        coordinates[myEnd++] = nextCoord[1];
        skipped = false;
      } else {
        skipped = true;
      }

      lastXCoord = nextCoord[0];
      lastYCoord = nextCoord[1];
      lastRel = nextRel;
    } // Last coordinate equals first or only one point to append:


    if (closed && skipped || i === offset + stride) {
      coordinates[myEnd++] = lastXCoord;
      coordinates[myEnd++] = lastYCoord;
    }

    return myEnd;
  };
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */


  CanvasBuilder.prototype.drawCustomCoordinates_ = function (flatCoordinates, offset, ends, stride, builderEnds) {
    for (var i = 0, ii = ends.length; i < ii; ++i) {
      var end = ends[i];
      var builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
      builderEnds.push(builderEnd);
      offset = end;
    }

    return offset;
  };
  /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   */


  CanvasBuilder.prototype.drawCustom = function (geometry, feature, renderer, hitDetectionRenderer) {
    this.beginGeometry(geometry, feature);
    var type = geometry.getType();
    var stride = geometry.getStride();
    var builderBegin = this.coordinates.length;
    var flatCoordinates, builderEnd, builderEnds, builderEndss;
    var offset;

    switch (type) {
      case _GeometryType["default"].MULTI_POLYGON:
        flatCoordinates =
        /** @type {import("../../geom/MultiPolygon.js").default} */
        geometry.getOrientedFlatCoordinates();
        builderEndss = [];
        var endss =
        /** @type {import("../../geom/MultiPolygon.js").default} */
        geometry.getEndss();
        offset = 0;

        for (var i = 0, ii = endss.length; i < ii; ++i) {
          var myEnds = [];
          offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
          builderEndss.push(myEnds);
        }

        this.instructions.push([_Instruction["default"].CUSTOM, builderBegin, builderEndss, geometry, renderer, _inflate.inflateMultiCoordinatesArray]);
        this.hitDetectionInstructions.push([_Instruction["default"].CUSTOM, builderBegin, builderEndss, geometry, hitDetectionRenderer || renderer, _inflate.inflateMultiCoordinatesArray]);
        break;

      case _GeometryType["default"].POLYGON:
      case _GeometryType["default"].MULTI_LINE_STRING:
        builderEnds = [];
        flatCoordinates = type == _GeometryType["default"].POLYGON ?
        /** @type {import("../../geom/Polygon.js").default} */
        geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
        offset = this.drawCustomCoordinates_(flatCoordinates, 0,
        /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */
        geometry.getEnds(), stride, builderEnds);
        this.instructions.push([_Instruction["default"].CUSTOM, builderBegin, builderEnds, geometry, renderer, _inflate.inflateCoordinatesArray]);
        this.hitDetectionInstructions.push([_Instruction["default"].CUSTOM, builderBegin, builderEnds, geometry, hitDetectionRenderer || renderer, _inflate.inflateCoordinatesArray]);
        break;

      case _GeometryType["default"].LINE_STRING:
      case _GeometryType["default"].CIRCLE:
        flatCoordinates = geometry.getFlatCoordinates();
        builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        this.instructions.push([_Instruction["default"].CUSTOM, builderBegin, builderEnd, geometry, renderer, _inflate.inflateCoordinates]);
        this.hitDetectionInstructions.push([_Instruction["default"].CUSTOM, builderBegin, builderEnd, geometry, hitDetectionRenderer || renderer, _inflate.inflateCoordinates]);
        break;

      case _GeometryType["default"].MULTI_POINT:
        flatCoordinates = geometry.getFlatCoordinates();
        builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);

        if (builderEnd > builderBegin) {
          this.instructions.push([_Instruction["default"].CUSTOM, builderBegin, builderEnd, geometry, renderer, _inflate.inflateCoordinates]);
          this.hitDetectionInstructions.push([_Instruction["default"].CUSTOM, builderBegin, builderEnd, geometry, hitDetectionRenderer || renderer, _inflate.inflateCoordinates]);
        }

        break;

      case _GeometryType["default"].POINT:
        flatCoordinates = geometry.getFlatCoordinates();
        this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
        builderEnd = this.coordinates.length;
        this.instructions.push([_Instruction["default"].CUSTOM, builderBegin, builderEnd, geometry, renderer]);
        this.hitDetectionInstructions.push([_Instruction["default"].CUSTOM, builderBegin, builderEnd, geometry, hitDetectionRenderer || renderer]);
        break;

      default:
    }

    this.endGeometry(feature);
  };
  /**
   * @protected
   * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */


  CanvasBuilder.prototype.beginGeometry = function (geometry, feature) {
    this.beginGeometryInstruction1_ = [_Instruction["default"].BEGIN_GEOMETRY, feature, 0, geometry];
    this.instructions.push(this.beginGeometryInstruction1_);
    this.beginGeometryInstruction2_ = [_Instruction["default"].BEGIN_GEOMETRY, feature, 0, geometry];
    this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
  };
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */


  CanvasBuilder.prototype.finish = function () {
    return {
      instructions: this.instructions,
      hitDetectionInstructions: this.hitDetectionInstructions,
      coordinates: this.coordinates
    };
  };
  /**
   * Reverse the hit detection instructions.
   */


  CanvasBuilder.prototype.reverseHitDetectionInstructions = function () {
    var hitDetectionInstructions = this.hitDetectionInstructions; // step 1 - reverse array

    hitDetectionInstructions.reverse(); // step 2 - reverse instructions within geometry blocks

    var i;
    var n = hitDetectionInstructions.length;
    var instruction;
    var type;
    var begin = -1;

    for (i = 0; i < n; ++i) {
      instruction = hitDetectionInstructions[i];
      type =
      /** @type {import("./Instruction.js").default} */
      instruction[0];

      if (type == _Instruction["default"].END_GEOMETRY) {
        begin = i;
      } else if (type == _Instruction["default"].BEGIN_GEOMETRY) {
        instruction[2] = i;
        (0, _array.reverseSubArray)(this.hitDetectionInstructions, begin, i);
        begin = -1;
      }
    }
  };
  /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   */


  CanvasBuilder.prototype.setFillStrokeStyle = function (fillStyle, strokeStyle) {
    var state = this.state;

    if (fillStyle) {
      var fillStyleColor = fillStyle.getColor();
      state.fillStyle = (0, _colorlike.asColorLike)(fillStyleColor ? fillStyleColor : _canvas.defaultFillStyle);
    } else {
      state.fillStyle = undefined;
    }

    if (strokeStyle) {
      var strokeStyleColor = strokeStyle.getColor();
      state.strokeStyle = (0, _colorlike.asColorLike)(strokeStyleColor ? strokeStyleColor : _canvas.defaultStrokeStyle);
      var strokeStyleLineCap = strokeStyle.getLineCap();
      state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : _canvas.defaultLineCap;
      var strokeStyleLineDash = strokeStyle.getLineDash();
      state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : _canvas.defaultLineDash;
      var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
      state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : _canvas.defaultLineDashOffset;
      var strokeStyleLineJoin = strokeStyle.getLineJoin();
      state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : _canvas.defaultLineJoin;
      var strokeStyleWidth = strokeStyle.getWidth();
      state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : _canvas.defaultLineWidth;
      var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
      state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : _canvas.defaultMiterLimit;

      if (state.lineWidth > this.maxLineWidth) {
        this.maxLineWidth = state.lineWidth; // invalidate the buffered max extent cache

        this.bufferedMaxExtent_ = null;
      }
    } else {
      state.strokeStyle = undefined;
      state.lineCap = undefined;
      state.lineDash = null;
      state.lineDashOffset = undefined;
      state.lineJoin = undefined;
      state.lineWidth = undefined;
      state.miterLimit = undefined;
    }
  };
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */


  CanvasBuilder.prototype.createFill = function (state) {
    var fillStyle = state.fillStyle;
    /** @type {Array<*>} */

    var fillInstruction = [_Instruction["default"].SET_FILL_STYLE, fillStyle];

    if (typeof fillStyle !== 'string') {
      // Fill is a pattern or gradient - align it!
      fillInstruction.push(true);
    }

    return fillInstruction;
  };
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */


  CanvasBuilder.prototype.applyStroke = function (state) {
    this.instructions.push(this.createStroke(state));
  };
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */


  CanvasBuilder.prototype.createStroke = function (state) {
    return [_Instruction["default"].SET_STROKE_STYLE, state.strokeStyle, state.lineWidth * this.pixelRatio, state.lineCap, state.lineJoin, state.miterLimit, this.applyPixelRatio(state.lineDash), state.lineDashOffset * this.pixelRatio];
  };
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */


  CanvasBuilder.prototype.updateFillStyle = function (state, createFill) {
    var fillStyle = state.fillStyle;

    if (typeof fillStyle !== 'string' || state.currentFillStyle != fillStyle) {
      if (fillStyle !== undefined) {
        this.instructions.push(createFill.call(this, state));
      }

      state.currentFillStyle = fillStyle;
    }
  };
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */


  CanvasBuilder.prototype.updateStrokeStyle = function (state, applyStroke) {
    var strokeStyle = state.strokeStyle;
    var lineCap = state.lineCap;
    var lineDash = state.lineDash;
    var lineDashOffset = state.lineDashOffset;
    var lineJoin = state.lineJoin;
    var lineWidth = state.lineWidth;
    var miterLimit = state.miterLimit;

    if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, _array.equals)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit) {
      if (strokeStyle !== undefined) {
        applyStroke.call(this, state);
      }

      state.currentStrokeStyle = strokeStyle;
      state.currentLineCap = lineCap;
      state.currentLineDash = lineDash;
      state.currentLineDashOffset = lineDashOffset;
      state.currentLineJoin = lineJoin;
      state.currentLineWidth = lineWidth;
      state.currentMiterLimit = miterLimit;
    }
  };
  /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */


  CanvasBuilder.prototype.endGeometry = function (feature) {
    this.beginGeometryInstruction1_[2] = this.instructions.length;
    this.beginGeometryInstruction1_ = null;
    this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
    this.beginGeometryInstruction2_ = null;
    var endGeometryInstruction = [_Instruction["default"].END_GEOMETRY, feature];
    this.instructions.push(endGeometryInstruction);
    this.hitDetectionInstructions.push(endGeometryInstruction);
  };
  /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */


  CanvasBuilder.prototype.getBufferedMaxExtent = function () {
    if (!this.bufferedMaxExtent_) {
      this.bufferedMaxExtent_ = (0, _extent.clone)(this.maxExtent);

      if (this.maxLineWidth > 0) {
        var width = this.resolution * (this.maxLineWidth + 1) / 2;
        (0, _extent.buffer)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
      }
    }

    return this.bufferedMaxExtent_;
  };

  return CanvasBuilder;
}(_VectorContext["default"]);

var _default = CanvasBuilder;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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